import { FieldKey } from "src/types";
import { MetaFieldType } from "src/app/methods/getMetaFieldTypeOptions";
import { doesDateMatchRange } from "./tableSortingUtils";

export const filterTableData = (rows, selectedFilters, userId) => {
  return rows.filter((row) =>
    ifRowMatchesFilters(row.original, selectedFilters, userId),
  );
};

const NULL_HANDLED_TYPES = [
  MetaFieldType.SingleSelect,
  MetaFieldType.DictionaryElement,
  MetaFieldType.Creator,
  MetaFieldType.Content,
  MetaFieldType.PublicationRelated,
  MetaFieldType.MultiSelect,
  MetaFieldType.AggregatedSelect,
];

export const ifRowMatchesFilters = (row, selectedFilters, userId) => {
  if (Object.keys(selectedFilters).length === 0 || row.id === "empty")
    return true;

  const activeFilterUuids = Object.keys(selectedFilters).filter(
    (uuid) => selectedFilters[uuid]?.value !== undefined,
  );

  return activeFilterUuids.every((filterUuid) => {
    const cellFilter = selectedFilters[filterUuid]?.value;

    const cell = row.metadata.find((c) => c.uuid === filterUuid);

    if (!cell) return false;

    if (
      !NULL_HANDLED_TYPES.includes(cell.type) &&
      !cell.value &&
      cell.type !== MetaFieldType.BoolVal
    ) {
      return false;
    }

    if (
      cell.type === MetaFieldType.SingleSelect &&
      cellFilter?.includes(cell.value)
    )
      return true;

    switch (cell.type) {
      case MetaFieldType.SingleSelect:
      case MetaFieldType.DictionaryElement:
      case MetaFieldType.Creator:
      case MetaFieldType.Content:
      case MetaFieldType.PublicationRelated:
        if (
          cellFilter.includes(cell.value) ||
          (cellFilter.includes(null) && cell.value === null)
        )
          return true;
        break;
      case MetaFieldType.MultiSelect:
      case MetaFieldType.AggregatedSelect:
        if (
          cellFilter?.some((value) => cell.value?.includes(value)) ||
          (cellFilter.includes(null) && cell.value === null)
        )
          return true;
        break;
      case MetaFieldType.Date:
        if (!cell.value?.date) return false;
        return doesDateMatchRange(cell.value.date, cellFilter);
      case MetaFieldType.BoolVal:
        return cell?.value === cellFilter;
      case MetaFieldType.Rating:
        if (cellFilter?.includes(String(cell.value))) return true;
        break;
      case MetaFieldType.Number:
      case MetaFieldType.Currency:
      case MetaFieldType.Percent:
        const rawFrom = cellFilter?.from;
        const rawTo = cellFilter?.to;

        const from =
          rawFrom !== undefined && rawFrom !== null && rawFrom !== ""
            ? Number(rawFrom)
            : null;

        const to =
          rawTo !== undefined && rawTo !== null && rawTo !== ""
            ? Number(rawTo)
            : null;

        if (
          (from === null || cell.value >= from) &&
          (to === null || cell.value <= to)
        ) {
          return true;
        }
        break;

      case MetaFieldType.Member:
        if (cellFilter.includes(cell.value)) return true;
        break;

      case MetaFieldType.Text:
        if (cell?.value?.toLowerCase()?.includes(cellFilter?.toLowerCase())) {
          return true;
        }
        break;
    }
    switch (cell.key) {
      case FieldKey.Completed:
        if (cell.value === true && cellFilter?.includes("completed"))
          return true;
        if (cell.value === false && cellFilter?.includes("incompleted"))
          return true;
        break;
      case FieldKey.Assignee:
        if (cell.value === userId && cellFilter?.includes("my_actions"))
          return true;
        break;
    }

    return false;
  });
};
